import {JobNodes, makeJobTaskDescriptor} from "@cm/job-nodes/job-nodes"

export type ArGltfGenerationInput = {
    templateRevisionId: string
    templateParametersBase64: string
    assignmentKey: string
}

export type ArGltfGenerationOutput = {
    dataObject: JobNodes.DataObjectReference
}

export const arGltfGenerationTask = makeJobTaskDescriptor<ArGltfGenerationInput, ArGltfGenerationOutput>("Ar.gltf", 1)

export type ArUsdzGenerationInput = {
    dataObject: JobNodes.DataObjectReference
}

export type ArUsdzGenerationOutput = {
    dataObject: JobNodes.DataObjectReference
}

export const arUsdzGenerationTask = makeJobTaskDescriptor<ArUsdzGenerationInput, ArUsdzGenerationOutput>("Ar.usdz", 1)

export const buildArJobGraph = (templateRevisionId: string, templateParametersBase64: string, assignmentKey: string, platformVersion?: string) => {
    const gltfGenerationTask = JobNodes.task(arGltfGenerationTask, {
        input: JobNodes.struct({
            templateRevisionId: JobNodes.value(templateRevisionId),
            templateParametersBase64: JobNodes.value(templateParametersBase64),
            assignmentKey: JobNodes.value(assignmentKey),
        }),
    })
    const usdzGenerationTask = JobNodes.task(arUsdzGenerationTask, {
        input: gltfGenerationTask,
    })
    return JobNodes.jobGraph(JobNodes.list([gltfGenerationTask, usdzGenerationTask]), {
        platformVersion,
    })
}
